var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconLocationPin = function SvgIconLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.31 1.75c4.982 0 9.034 4.052 9.034 9.034 0 2.685-1.467 6.002-3.92 9.673a51.862 51.862 0 0 1-2.726 3.699l-.376.462c-.3.364-.562.673-.777.92l-.235.266a1.344 1.344 0 0 1-2 0l-.37-.421a46.647 46.647 0 0 1-.642-.765l-.376-.462a51.862 51.862 0 0 1-2.726-3.699c-2.453-3.671-3.92-6.988-3.92-9.673 0-4.982 4.052-9.034 9.034-9.034zm0 2.688a6.353 6.353 0 0 0-6.345 6.346c0 2.887 2.547 7.34 6.026 11.652l.319.392.319-.392.622-.785c3.157-4.062 5.404-8.155 5.404-10.867a6.353 6.353 0 0 0-6.345-6.346zm0 2.557c2.09 0 3.788 1.7 3.788 3.789a3.791 3.791 0 0 1-3.788 3.788 3.792 3.792 0 0 1-3.789-3.788c0-2.09 1.7-3.789 3.789-3.789zm0 2.107c-.927 0-1.682.755-1.682 1.682 0 .927.755 1.682 1.682 1.682.927 0 1.682-.755 1.682-1.682 0-.927-.755-1.682-1.682-1.682z",
    fill: "none",
    fillRule: "evenodd"
  })));
};

export default SvgIconLocationPin;